import React from "react"
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'
import clearProps from '../../utils/clearProps'

export default class LinkDetails extends React.Component {
  constructor(props) {
    super(props)

    this.config = { 
      types : [ 
        'inverse',
      ],
      modifiers : [],
      states : []
    }
  }

  renderLinkDetailsGroup(data) {
    const listItems = data.map((link, index) => 
      <div  key={index} className="mdn-LinkDetails-group">
        <div className="mdn-Link mdn-Link--arrow">
          <a {...link.linkProps} className="mdn-Link-anchor" target={link.target} href={link.href}>
            {link.title}
          </a>
          <span className="mdn-Link-anchor-icon mdn-Icon-direita mdn-Icon--md"></span>
        </div>
        <p className="mdn-Text mdn-Text--caption">
          {link.description}
        </p>
      </div>
      )
     return listItems
  }
  
  render() {
    const { data, ...rest } = this.props
    const props = clearProps(this.props)
    return <div {...rest} className={resolveProps(this.props, this.config, 'LinkDetails') }>
    {this.renderLinkDetailsGroup(data)}
  </div>
  }
}

LinkDetails.propTypes = {
  data : PropTypes.array
}